import { render, staticRenderFns } from "./template.html?vue&type=template&id=ecd9a466&scoped=true&"
import script from "./SidenaviLine.vue?vue&type=script&lang=ts&"
export * from "./SidenaviLine.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=ecd9a466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd9a466",
  null
  
)

export default component.exports